import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"
import consumer from "../../assets/javascript/channels/consumer"

export default class extends Controller {
  static targets = ["spinner", "button"]

  connect() {
    const that = this

    consumer.subscriptions.create({ channel: 'FileDownloadChannel', room: 'main' }, {
      received(data) {
        if(data.message.filename) {
          that.spinnerTarget.style.display = "none"
          that.buttonTarget.classList.add('option-row');
          that.buttonTarget.classList.remove('option-row-disabled');
          window.location.href = `/download_file?filename=${data.message.filename}`
        }
      }
    })
  }

  disconnect() {}

  async mass_export() {
    this.spinnerTarget.style.display = "block"
    this.buttonTarget.classList.remove('option-row');
    this.buttonTarget.classList.add('option-row-disabled');

    const model = this.element.getAttribute("data-model-bulk-actions-model-value")

    let response = await get(`/${model}/mass_export`, { responseKind: 'turbo-stream' })

    if (response.ok) {
      console.log('descargando...', response)
    } else {
      console.log('error!!', response)
    }
  }
}
